import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VCard,{staticClass:"pa-3",attrs:{"id":_vm.$style.endpoint,"flat":"","tile":""}}),(_vm.lastModifiedDateTime != '')?_c(VRow,{staticClass:"pl-4 pr-4",attrs:{"justify":"end"}},[_vm._v(" 更新日時："+_vm._s(_vm.lastModifiedDateTime)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }